// extracted by mini-css-extract-plugin
export default {"container":"seperator_container__7Z+OE","line":"seperator_line__ryZOE","word":"seperator_word__tbNlp"};